import DropOffTask from 'components/hyperdrive/createTask/DropOffTask';
import React from 'react';

export default function DropOffTaskDrawer({ closeModal }) {
  return (
    <DropOffTask closeModal={closeModal} />
  );
}
